import { render } from "./AuthNavbar.vue?vue&type=template&id=45d4d5da"
import script from "./AuthNavbar.vue?vue&type=script&lang=js"
export * from "./AuthNavbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../bfms-portal-template-manager-20261102/stage/fms_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__